import React, { Component, RefObject } from 'react';

import { ThemeConfiguration, ThemeContext } from './ThemeContext';

const isRefObject = (ref: any): boolean =>
  ref !== null && typeof ref === 'object' && ref.hasOwnProperty('current');

interface ThemeProps {
  reference: RefObject<any> | HTMLElement;
  theme: ThemeConfiguration;
}

export class Theme extends Component<React.PropsWithChildren<ThemeProps>> {
  componentDidMount() {
    this.updateCSSVariables();
  }

  componentDidUpdate(prevProps: ThemeProps) {
    if (this.props.theme !== prevProps.theme) {
      this.updateCSSVariables();
    }
  }

  updateCSSVariables() {
    const { theme, reference } = this.props;
    const element = isRefObject(reference)
      ? (reference as RefObject<any>).current
      : reference;

    if (element) {
      for (const prop in theme.variables) {
        element.style.setProperty(prop, theme.variables[prop]);
      }
    }
  }

  render() {
    return (
      <ThemeContext.Provider value={this.props.theme}>
        {this.props.children}
      </ThemeContext.Provider>
    );
  }
}
